module.exports = __webpack_public_path__ + "static/empty.a2f369ee.png";